export class CalendarioSsoCreateDefaultModel{
    anio?: number

}